import { NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { useRegisterStore } from '@public/stores/register';
const routes: RouteRecordRaw[] = [
	{
		path: '/rejestracja',
		redirect: '/rejestracja/wybierz-klientow',
	},
	{
		path: '/rejestracja/wybierz-klientow',
		name: 'RegisterPage',
		component: () => import('@public/register/RegisterPage.vue'),
		meta: {
			noDecorate: true,
		},
		beforeEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
			const registerStore = useRegisterStore();
			const preventChild = Number(to.meta.step) && registerStore.isLoading;
			if (preventChild) {
				next('/rejestracja/wybierz-klientow');
			} else {
				next();
			}
		},
		children: [
			{
				path: '',
				name: 'RegisterIntro',
				component: () => import('@public/register/RegisterIntro.vue'),
			},
			{
				path: '1',
				name: 'RegisterAdditional',
				component: () => import('@public/register/RegisterAdditional.vue'),
				meta: {
					step: 1,
				},
			},
			{
				path: '2',
				name: 'RegisterLocations',
				component: () => import('@public/register/RegisterLocations.vue'),
				meta: {
					step: 2,
				},
			},
			{
				path: '3',
				name: 'RegisterContact',
				component: () => import('@public/register/RegisterContact.vue'),
				meta: {
					step: 3,
				},
			},
			{
				path: '4',
				name: 'RegisterFinish',
				component: () => import('@public/register/RegisterFinish.vue'),
				meta: {
					step: 4,
				},
			},
		],
	},
	{
		path: '/konto/formularz-kontaktowy',
		name: 'ContactPage',
		component: () => import('@public/contact-page/ContactPage.vue'),
	},
	{
		path: '/ofertech',
		name: 'ChatBot',
		component: () => import('@public/chatbot/ChatBot.vue'),
	},
	{
		path: '/ofertech-widget',
		name: 'ChatBotWidget',
		component: () => import('@public/chatbot/ChatBotWidget.vue'),
	},
	{
		path: '/draft',
		name: 'DraftPage',
		component: () => import('@public/draft/DraftPage.vue'),
		meta: {
			noDecorate: true,
		},
	},
	{
		path: '/wystaw-opinie',
		children: [
			{
				path: ':idCustomer/:dodaj(dodaj)?',
				name: 'ReviewFormMinimal',
				component: () => import('@public/review-form/ReviewFormPage.vue'),
			},
			{
				path: ':idCustomer/:sourceId/:idRfp/:dodaj(dodaj)?',
				name: 'ReviewForm',
				component: () => import('@public/review-form/ReviewFormPage.vue'),
			},
			{
				path: ':idCustomer/:sourceId/:idRfp/ocena/:rating/:dodaj(dodaj)?',
				name: 'ReviewFormWithRating',
				component: () => import('@public/review-form/ReviewFormPage.vue'),
			},
			{
				path: 'aktywuj/:reviewId/:ack?/:dodaj(dodaj)?',
				name: 'ReviewFormActivate',
				component: () => import('@public/review-form/ReviewFormPage.vue'),
			},
			{
				path: ':dodaj(dodaj)?',
				name: 'ReviewFormBase',
				component: () => import('@public/review-form/ReviewFormPage.vue'),
			},
		],
	},
];

export default routes;
